import Wrap from './styles';

export default (props) => {
  return (
    <Wrap>
      <p>Página de Login</p>
    </Wrap>
  );
};
